import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { fadeInRightAnimation } from "src/@fury/animations/fade-in-right.animation";
import { fadeInUpAnimation } from "src/@fury/animations/fade-in-up.animation";
import { scaleInAnimation } from "src/@fury/animations/scale-in.animation";
import { ApiService } from "src/app/services/api.service";
import { Location } from "@angular/common";
import endpoints from "src/app/helpers/endpoints";
import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { ErrorType } from "src/app/enums/error-type.enum";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "fury-add-edit-status",
  templateUrl: "./add-edit-status.component.html",
  styleUrls: ["./add-edit-status.component.scss"],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class AddEditStatusComponent implements OnInit, OnDestroy {
  parentlist = [];
  statusId: string = "";
  statusForm = new FormGroup<any>({
    statusName: new FormControl<string>("", [Validators.required]),
    description: new FormControl<string>("", [Validators.required])
  });
  ngUnSubscribe = new Subject<void>();
  constructor(
    private apiService: ApiService,
    private ar: ActivatedRoute,
    public location: Location
  ) {}

  ngOnInit(): void {
    this.ar.params.pipe(takeUntil(this.ngUnSubscribe)).subscribe((res) => {
      if (res) {
        this.statusId = res["statusId"];
        if (this.statusId) this.getDetails();
      }
    });
  }

  getDetails() {
    this.apiService
      .get(endpoints.settings.statusManagement.getStatusDetails(this.statusId))
      .pipe(takeUntil(this.ngUnSubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res?.body) {
            this.statusForm.patchValue(res.body?.emailTemplateStatus);
          }
        },
      });
  }
  submit() {
    if (this.statusForm.valid) {
      const data = this.statusForm.getRawValue();
      const apiMethod = this.statusId
        ? this.apiService.patch(
            endpoints.settings.statusManagement.updateStatus(this.statusId),
            data
          )
        : this.apiService.post(
            endpoints.settings.statusManagement.createStatus,
            data
          );

      apiMethod.pipe(takeUntil(this.ngUnSubscribe)).subscribe(
        (res: HttpResponse<any>) => {
          this.apiService.alert(res.body?.message, ErrorType.Success);
          this.location.back();
        },
        (err: HttpErrorResponse) => {
          this.apiService.alert(err.message, ErrorType.Error);
        }
      );
    } else {
      this.statusForm.markAllAsTouched();
    }
  }
  ngOnDestroy(): void {
    this.ngUnSubscribe.next();
    this.ngUnSubscribe.complete();
  }
}
